/**
 * KDS → Chakra mappings for Button (Kintsugi Design System node 1045:13557).
 *
 * KDS axis            Chakra prop
 * ─────────────────────────────────────────
 * Type: Filled        variant="solid"
 * Type: Outlined      variant="outline"
 * Type: Ghosted       variant="ghost"
 *
 * Color: Accent       colorPalette="neonGreen"
 * Color: Primary      colorPalette="brand"
 * Color: Secondary    colorPalette="neutral"
 * Color: Destructive  colorPalette="red"
 *
 * Size: Large         size="lg"  (48px)  px 12px  outline border 2px
 * Size: Medium        size="md"  (40px)  px 12px  outline border 1.5px
 * Size: Regular       size="rg"  (32px)  px 8px   outline border 1px
 * Size: Small         size="sm"  (24px)  px 6px   outline border 1px
 */
export const buttonColorPalette = {
  accent: 'neonGreen',
  primary: 'brand',
  secondary: 'neutral',
  destructive: 'red',
} as const;

export type ButtonColor = keyof typeof buttonColorPalette;

/** Horizontal padding (px) per KDS button size. */
export const buttonPaddingX = {
  lg: '12px',
  md: '12px',
  rg: '8px',
  sm: '6px',
} as const;

/** Gap between label and icons (px) per KDS button size. */
export const buttonGap = {
  lg: '8px',
  md: '6px',
  rg: '4px',
  sm: '4px',
} as const;

/** Outlined type border width (px) per KDS size. */
export const buttonOutlineBorderWidth = {
  lg: '2px',
  md: '1.5px',
  rg: '1px',
  sm: '1px',
} as const;

/** Icon box size (px) paired with each KDS button size. */
export const buttonIconSizePx = {
  lg: 22,
  md: 20,
  rg: 18,
  sm: 16,
} as const;

export type ButtonSize = keyof typeof buttonIconSizePx;

/** Square dimensions for icon-only buttons (Figma IconButton set). */
export const iconButtonSquareSize = {
  lg: { w: '48px', minW: '48px', px: '0' },
  md: { w: '40px', minW: '40px', px: '0' },
  rg: { w: '32px', minW: '32px', px: '0' },
  sm: { w: '24px', minW: '24px', px: '0' },
} as const;
